import { render, staticRenderFns } from "./CheckboxControl.vue?vue&type=template&id=219e4a85&scoped=true&"
import script from "./CheckboxControl.vue?vue&type=script&lang=js&"
export * from "./CheckboxControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e4a85",
  null
  
)

export default component.exports